export default {
  title: 'Päällekkäinen tarjous samalla ajanjaksolla',
  buttons: {
    save_as_active: 'Aseta uudeksi aktiiviseksi tarjoukseksi',
    save_as_inactive: 'Tallenna ei-aktiivisena',
    cancel: 'Peruuta',
  },
  description: {
    base: '{{offer}} on päällekkäinen aktiivisen tarjouksen {{overlappingOffer}} kanssa päivänä {{weekday}}{{between}}. Voit käyttää vain yhtä tarjousta samalla ajanjaksolla.',
    between: ', välillä {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Ratkaisu: Valitse yksi vaihtoehto alta.',
  },
};
